export default {
	api_url : 'https://api.transcripts.theananda.org',
	mp_api_url : 'https://api.mp.theananda.org',
	google_analytic_id : 'UA-86740736-5',
	pdf_download_source : 'https://data.theananda.org/transcript/'
}
